import React from "react";
import RegularButton from "components/CustomButtons/Button"
import DeleteIcon from '@material-ui/icons/Delete';
import { useDispatch } from "react-redux";
import { Box } from "@material-ui/core";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import EditIcon from '@material-ui/icons/Edit';
import { useToggle } from "hooks/useToggle";
import { ModalV2 } from "components/Modal/ModalV2";
import { useForm } from "hooks/useForm";
import { removeConditionCustomer } from "redux/actions/customers/customersAction";
import { EditConditionForm } from "./EditConditionForm";
import { editConditionCustomer } from "redux/actions/customers/customersAction";

const colors = {
  success: '#4caf50',
  error: '#f6685e',
  info: '#4092E5'
}

export const columnsCondition = [
  {
    Header: 'Condición',
    accessor: 'name',
    filterable: true,
    filterMethod: (filter, row) => { return row.name.toLowerCase().includes(filter.value.toLowerCase()) },
  },
  {
    Header: 'Cantidad',
    accessor: 'quantity',
    filterable: false,
  },
  {
    Header: 'Descripcion',
    accessor: 'description',
    filterable: false,
  },
  {
    Header: 'Acciones',
    filterable: true,
    Cell: ({ original }) => {
      const { id } = useParams();
      const dispatch = useDispatch();
      const [open, setOpen] = useToggle()
      const [openDel, setOpenDel] = useToggle()

      const handleRemove = () => {
        dispatch(removeConditionCustomer(id, original.id))
      }
      return (
        <>
          <Box style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <RegularButton
              justIcon
              round
              color="transparent"
              tooltip="Editar"
              size="sm"
              onClick={setOpen}
            >
              <EditIcon style={{ margin: 0, color: colors.info }} />
            </RegularButton>
            <RegularButton
              justIcon
              round
              color="transparent"
              tooltip="Remover"
              size="sm"
              onClick={setOpenDel}
            >
              <DeleteIcon style={{ margin: 0, color: colors.error }} />
            </RegularButton>
          </Box>
          <ModalV2
            open={open}
            onClose={setOpen}
            title='Editar Condición'
            justConfirm
          >
            <EditConditionForm original={original} onClose={setOpen} />
          </ModalV2>
          <ModalV2
            open={openDel}
            onClose={setOpenDel}
            title='¿Desea eliminar esta condición?'
            justConfirm
            onSubmit={handleRemove} />
        </>
      )
    }
  }
]